import { useSearchParams } from "react-router";
import { InvestmentTypeEnum } from "@rentablo/api/apiv1";
import { LoadingProgressBar } from "@rentablo/components";
import { ManualTransactionWizard } from "./ManualTransactionWizard";
import { useDepotInitialCurrency } from "./hooks/useDepotInitialCurrency";

export const ManualTransactionWizardWithRouting = () => {
  const [searchParams] = useSearchParams();

  const type = searchParams.get("type");
  const depotIdParam = searchParams.get("depotId");
  const depotId = depotIdParam ? Number.parseInt(depotIdParam, 10) : undefined;

  const { initialCurrency, isLoading } = useDepotInitialCurrency(depotId);

  if (isLoading) return <LoadingProgressBar />;

  return (
    <ManualTransactionWizard
      type={type as InvestmentTypeEnum}
      depotId={depotId}
      initialCurrency={initialCurrency}
    />
  );
};
